import { render } from "./SSN.vue?vue&type=template&id=1b972217"
import script from "./SSN.vue?vue&type=script&lang=js"
export * from "./SSN.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__